<template>
    <i class="fa fa-info-circle text-info ml-1" v-tooltip="tooltip"/>
</template>

<script>
export default {
    name: "InfoCircle",
    props: {
        tooltip: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>

</style>